export default class Exception extends Error {
  public code: string;
  public reason?: string;

  constructor(code: string, message: string, reason?: string) {
    super(message);

    Object.setPrototypeOf(this, Exception.prototype);

    this.name = 'Exception';
    this.code = code;
    this.reason = reason;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, Exception);
    }
  }

  public toString(): string {
    return this.reason
      ? `${this.name}: ${this.code} | ${this.message} | Reason: ${this.reason}`
      : `${this.name}: ${this.code} | ${this.message}`;
  }
}
